import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { addToRefsGeneric } from "../../utils/funtions";
import { Pause, Play } from "../../icons";
import gsap from "gsap";

export const HeroVideo = () => {
  const theme = useTheme();
  const brandName = "Nikolay";
  const brandCountry = "Orlando";
  const brandNameRef = useRef<HTMLElement[]>([]);
  const addTextReff = addToRefsGeneric(brandNameRef);

  const [video, setVideo] = useState(true);
  const videoHeroRef = useRef<HTMLVideoElement | null>(null);

  const onSecondVideo = () => {
    if (videoHeroRef.current) {
      if (video) {
        setVideo(false);
        videoHeroRef.current.pause();
      } else {
        setVideo(true);
        videoHeroRef.current.play();
      }
    }
  };

  useEffect(() => {
    const ctx = gsap.context(() => {
      if (!brandNameRef) return;
      brandNameRef.current.forEach((el, i) => {
        gsap.fromTo(
          el,
          {
            y: 12,
            opacity: 0,
            filter: "blur(10px)",
            transformPerspective: 1000,
            rotateX: 0.01,
          },
          {
            y: 0,
            opacity: 1,
            filter: "blur(0px)",
            delay: 0.1 * i,
            duration: 0.8,
            scrollTrigger: {
              trigger: brandNameRef.current[0],
              start: "top 100%",
              once: true,
            },
          }
        );
      });
    });
    return () => ctx.revert();
  }, []);

  return (
    <Box
      position="relative"
      height={{ xs: 250, sm: 450, md: "calc(100svh - 60px)" }}
    >
      <Box
        width="100%"
        position="absolute"
        bottom={0}
        boxShadow={{
          xs: undefined,
          md: "0px 0px 100px 200px rgba(0, 0, 0, 0.95)",
        }}
      />
      <Box
        sx={{
          width: "100%",
          height: { xs: 250, sm: 450, md: "calc(100svh - 60px)" },
          overflow: "hidden",
        }}
      >
        <video
          ref={videoHeroRef}
          poster="https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/home/poster.jpg"
          src="https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/home/home.mp4"
          autoPlay={video}
          muted
          loop
          playsInline
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </Box>

      <Box
        position="absolute"
        display="flex"
        flexDirection="column"
        gap={3}
        zIndex={99}
        left={{ xs: 20, md: 50 }}
        bottom={{ xs: 25, md: 70 }}
      >
        <Typography
          ref={addTextReff}
          sx={{
            fontSize: { xs: 12, sm: 20, md: 25 },
            color: theme.palette.background.paper,
            zIndex: 9,
            lineHeight: { xs: 0, md: 0.3 },
            fontWeight: 700,
            willChange: "transform, opacity",
          }}
        >
          Welcome
        </Typography>
        <Box display="flex" zIndex={9}>
          {brandName.split("").map((char, i) => (
            <Typography
              key={i}
              ref={addTextReff}
              sx={{
                fontSize: { xs: 30, sm: 50, md: 65 },
                color: theme.palette.background.default,
                lineHeight: 1,
                fontWeight: 800,
                willChange: "transform, opacity",
                textTransform: "uppercase",
                display: "inline-block",
                whiteSpace: "pre",
              }}
            >
              {char}
            </Typography>
          ))}
          <Typography
            ref={addTextReff}
            sx={{ color: "white", lineHeight: 0, fontSize: { xs: 12, md: 20 } }}
          >
            ®
          </Typography>
        </Box>
        <Box display="flex" zIndex={9}>
          {brandCountry.split("").map((char, i) => (
            <Typography
              key={i}
              ref={addTextReff}
              sx={{
                fontSize: { xs: 15, sm: 21, md: 35 },
                color: theme.palette.background.default,
                lineHeight: { xs: 0, md: 0.3 },
                letterSpacing: { xs: 9.8, md: 19.5 },
                fontWeight: 700,

                willChange: "transform, opacity",
                textTransform: "uppercase",
                display: "inline-block",
                whiteSpace: "pre",
                mr: char === " " ? "0.3rem" : 0,
              }}
            >
              {char}
            </Typography>
          ))}
        </Box>
      </Box>

      <Box
        position="absolute"
        bottom={{ xs: 25, md: 70 }}
        zIndex={99}
        right={{ xs: 20, md: 60 }}
      >
        <IconButton
          onClick={onSecondVideo}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: { xs: 30, md: 40 },
            height: { xs: 30, md: 40 },
            backdropFilter: "saturate(180%) blur(5px)",
            backgroundColor: theme.palette.background.paper,
            borderRadius: "100vmax !important",
            "&:hover": {
              backgroundColor: theme.palette.background.paper,
            },
          }}
        >
          {!video ? (
            <Play
              sx={{ width: { xs: 15, md: 19 }, height: { xs: 15, md: 19 } }}
            />
          ) : (
            <Pause
              sx={{ width: { xs: 15, md: 19 }, height: { xs: 15, md: 19 } }}
            />
          )}
        </IconButton>
      </Box>
    </Box>
  );
};
